import React from 'react';
import { useTranslation } from 'react-i18next';
import Hint from './hint';

interface Props {
  className: string;
}

const TEXT_TRANSLATION_KEY = 'signup-flow.domain.product.hint.special_chars_transformed.text';

const ProductDomainTransformedHint: React.FC<Props> = (props) => {
  const { t } = useTranslation();

  return <Hint className={props.className} html={t(TEXT_TRANSLATION_KEY)} />;
};

export default ProductDomainTransformedHint;
